import React from "react";
import {
  BeneficiaryInvestmentProfile,
  DropdownInvestmentOption,
  InvestmentOptionAPIType,
} from "@/types/investmentProfile";
import BeneficiaryCard from "./BeneficiaryCard";

interface InvestmentProfileListProps {
  beneficiaries: BeneficiaryInvestmentProfile[];
  getAcademicYearOptions: (beneficiaryId: number) => DropdownInvestmentOption[];
  getFilteredInvestmentOptions: (
    academicYear: string
  ) => DropdownInvestmentOption[];
  getSelectedPortfolioDetails: (
    investmentOptionId: string
  ) => InvestmentOptionAPIType | null;
  onCustomPlanSelection: (index: number, investmentOption: string) => void;
  onAcademicYearSelection: (index: number, academicYear: string) => void;
  isUserEnrolled?: boolean;
}

const InvestmentProfileList: React.FC<InvestmentProfileListProps> = ({
  beneficiaries,
  getAcademicYearOptions,
  getFilteredInvestmentOptions,
  getSelectedPortfolioDetails,
  onCustomPlanSelection,
  onAcademicYearSelection,
  isUserEnrolled,
}) => {
  return (
    <div
      className={`${
        !isUserEnrolled &&
        "text-[18px] shadow-introBox font-outfit bg-white w-full rounded-[16px]"
      }`}
    >
      {beneficiaries.map((beneficiary, index) => (
        <BeneficiaryCard
          key={beneficiary.id}
          beneficiary={beneficiary}
          isLastItem={index === beneficiaries.length - 1}
          getAcademicYearOptions={getAcademicYearOptions}
          getFilteredInvestmentOptions={getFilteredInvestmentOptions}
          getSelectedPortfolioDetails={getSelectedPortfolioDetails}
          onOptionChange={onCustomPlanSelection}
          onAcademicYearChange={onAcademicYearSelection}
          index={index}
          isUserEnrolled={isUserEnrolled}
        />
      ))}
    </div>
  );
};

export default InvestmentProfileList;
